import { ITableReport, Report } from "../../Interfaces/TableInterfaces";
import { addSeperatorToInput } from "../../helper";
import { CommonTableUI } from "../TableTemplate/common";
import PrioritySequence from "./PrioritySequence";

interface ExcelNLegPreviewRow extends ITableReport {
  sendOrder?: string;
  maxPositionPair?: number | string | null;
}

const ExcelNLegOrderPreviewTable = <TRow extends ExcelNLegPreviewRow>({ reports }: {
  reports: Report<TRow>;
}) => (
  <CommonTableUI
    reports={reports}
    renderCell={(row, header) => {
      if (header.headerName === "SendOrder") return <PrioritySequence value={row.sendOrder} />;
      if (header.headerName === "MaxPositionPair")
        return <span dir="ltr">{addSeperatorToInput(row.maxPositionPair?.toString(), "negativeDecimalNumbers") || "-"}</span>;
      return undefined;
    }}
  />
);

export default ExcelNLegOrderPreviewTable;
